import React, { useState } from "react";
import Logo from "../../Assests/Images/tfs_logo.png";
import styles from "./CreateAccount.module.scss";
import Card from "../../Components/Atoms/Card/Card";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import {
  FormDropdown,
  FormField,
  FormFieldMail,
} from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PrimaryButton } from "../../Components/Atoms/Button/Button";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import {customer_set_password} from "../../Enums/api_constunts"
import {postMethod} from "../../Helpers/services"
import _ from "lodash";
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
export default function CustomerSetPassword() {
//sulc bzhl knyx iobz 
  const navigateTo = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const location = useLocation();

  const handleSubmit = (values) => {
    setIsSpinner(true)
    
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const userId = queryParams.get('user_id');
    if(queryParams.get("customer")){
      values["customer"] = queryParams.get("customer")
    }
    values["customer"] = 1
    values["token"] = token
    values["user_id"] = parseInt(userId)
    postMethod(customer_set_password,values).then((result)=>{
      showToast("success",_.get(result, "message","Something went wrong!"))  
       setIsSpinner(false);
       navigateTo("/customer-login")
       
     }).catch((error)=>{
       showToast("error",_.get(error, "message","Something went wrong!"))
       setIsSpinner(false);
       
     })
  };

  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")  // Minimum length should be 8
        .max(16, "Password cannot exceed 16 characters")
        .required("Please enter your password"),

      confirm_password: Yup.string()
        .min(8, "Confirmation Password must be at least 8 characters")  // Minimum length should be 8
        .max(16, "Confirmation Password cannot exceed 16 characters")
        .required("Please confirm your password")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),  // Ensure the confirmation password matches the password
    }),
    onSubmit: handleSubmit,
  });

  const handleKeyDown = (event) => {
    
    if (event.key === 'Enter') {
      
      formik.handleSubmit()
      
    }
  };

  return (
    <div className={styles.outer_container}>
      <div>
        {/* <div className="d-flex justify-content-between align-items-center bg-light position-absolute">
          <img src={Logo} alt="logo" height="70px" />
        </div> */}

        <div className={styles.create_account}>
          <div className={styles.create_account_container}>
            <Card className={styles.cardDetails}>
              <div className="text-center">
                <img src={Logo} alt="logo" height="70px" />
                <p className="d-flex flex-column mt-1">
                  <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
                    Set Password
                  </span>
                  {/* <span className="fs-6 lh-1 mt-3">Welcome back!</span> */}
                </p>
              </div>
              {/* <p className="d-flex flex-row mt-1 text-center justify-content-center">
                <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
                  Create an account
                </span>
              </p> */}
              <div className="d-flex flex-column justify-content-center align-items-center mt-3">
              
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Password"
                    id="password"
                    name="password"
                    type="password"
                    value={formik.values.password}
                    onChange={(e) =>
                      formik.setFieldValue("password", e.target.value)
                    }
                    error={formik.touched.password && formik.errors.password}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.password && <ErrorLabel name="password" formik={formik} message={formik.errors.password} />}
                </div>
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Confirm Password"
                    id="confirm_password"
                    name="confirm_password"
                    type="password"
                    value={formik.values.confirm_password}
                    onChange={(e) =>
                      formik.setFieldValue("confirm_password", e.target.value)
                    }
                    error={formik.touched.confirm_password && formik.errors.confirm_password}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.confirm_password && <ErrorLabel name="confirm_password" formik={formik} message={formik.errors.confirm_password} />}
                </div>
               
              </div>
              <div className="text-center">
                 <PrimaryButton
                    label="Submit"
                    className={styles.otpButton}
                    onClick={formik.handleSubmit}
                    disabled={!(formik.dirty && formik.isValid)}
                    spinner={isSpinner}
                  />
              </div>
              <p
                className={`fs-3 lh-1 fw-bold text-center ${styles.logintext}`}
                onClick={() => navigateTo("/customer-login")}
              >
                Back to Login
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

const serviceOptions = [
  { label: "Service 1", id: "service1" },
  { label: "Service 2", id: "service2" },
  { label: "Service 3", id: "service3" },
  { label: "Service 4", id: "service4" },
  { label: "Service 5", id: "service5" },
  { label: "Service 6", id: "service6" },
  { label: "Service 7", id: "service7" },
  { label: "Service 8", id: "service8" },
  { label: "Service 9", id: "service9" },
  { label: "Service 10", id: "service10" },
];
